import { Alert, Box, Button, CircularProgress } from '@mui/material';

/**
 * Marco común de cada pestaña: primera carga, error con reintento y recarga que conserva lo que ya se veía
 * (atenuado, sin saltos de layout).
 */
export default function ReportState({ report, children }) {
  if (report.loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress size={28} /></Box>;
  }
  return (
    <Box>
      {report.error && (
        <Alert severity="error" sx={{ mb: 2 }} action={<Button color="inherit" size="small" onClick={report.reload}>Reintentar</Button>}>
          {report.error}
        </Alert>
      )}
      <Box sx={{ opacity: report.refreshing ? 0.5 : 1, transition: 'opacity 150ms' }}>{children}</Box>
    </Box>
  );
}
